import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import AffiliateOverview from "./overview";
import AffiliateRetentionProgram from "./retention-program";
import AffiliateCommission from "./commission";
import AffiliateCampaigns from "./campaigns";
import AffiliateRefferedUsers from "./referred-users";
import CampaignFunds from "./funds";
import SvgIcon from "../../components/svg-icon";

const tabs = [
    "overview",
    "retention-program",
    "commission",
    "funds",
    "referred-users",
    "campaigns"
]
const Settings = () => {

    const {t} = useTranslation()

    const [activeTab, setActiveTab] = useState('overview')
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        const tab = searchParams.get('tab')
        if (tab && tabs.includes(tab))
            setActiveTab(tab)
    }, [searchParams])

    const handleTab = (tab) => {
        setSearchParams({tab: tab})
    }

    const getContent = () => {
        switch (activeTab) {
            case 'overview':
                return <AffiliateOverview/>


            case 'retention-program':
                return <AffiliateRetentionProgram/>

            case 'funds':
                return <CampaignFunds/>
            case 'commission':
                return <AffiliateCommission/>


            case "campaigns":
                return <AffiliateCampaigns/>


            case "referred-users":
                return <AffiliateRefferedUsers/>

            default:
                return null
        }
    }

    return (
        <div className="section section--first">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1 className="section__title section__title--head">
                            {t('affiliate.title')}
                        </h1>
                    </div>
                    <div className="col-12">
                        <div className="content">
                            <div className="dropdown content__dropdown">
                                <button
                                    className="dropdown-toggle content__dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {t('affiliate.tabs.overview')}

                                    <SvgIcon id={'right-down'}/>

                                </button>
                                <ul
                                    className="dropdown-menu content__dropdown-menu"
                                    aria-labelledby="dropdownMenuButton">

                                    {
                                        tabs?.map(tab => (
                                            <li key={tab}>
                                                <button
                                                    onClick={e => handleTab(tab)}
                                                    className="dropdown-item content__dropdown-item"
                                                    type="button">
                                                    <SvgIcon id={'arrow-dash'}/>
                                                    {t(`affiliate.tabs.${tab}`)}

                                                </button>
                                            </li>
                                        ))
                                    }

                                </ul>
                            </div>


                            <div className="content__menu">
                                <ul
                                    className="nav nav-tabs content__nav"
                                    id="content__nav"
                                    role="tablist"
                                >
                                    {
                                        tabs?.map(tab => (
                                            <li key={tab} className="nav-item" role="presentation">
                                                <button
                                                    onClick={e => handleTab(tab)}
                                                    className={activeTab === tab ? 'active' : ''}
                                                    type="button"
                                                >

                                                    <SvgIcon id={'arrow-dash'}/>
                                                    {t(`affiliate.tabs.${tab}`)}

                                                </button>
                                            </li>
                                        ))
                                    }

                                </ul>
                            </div>


                            <div className="content__main">
                                <div className="tab-content">
                                    {
                                        getContent()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default Settings
